import o from "process";
import { inIframe as s } from "../deviceUtils.js";
o.env.NODE_ENV === "production" || location.protocol.startsWith("https");
const e = o.env.NODE_ENV === "test", c = s(), i = (t) => !e && console.debug(t);
export {
  i as debug,
  c as isInIframe,
  e as isTest
};
//# sourceMappingURL=initConfig.js.map
